module.exports = __webpack_public_path__ + "img/subscription.df93fad9.png";